import React, { useState, useEffect } from 'react';
import SnackbarBase from '@material-ui/core/Snackbar';
import SnackbarContentBase from '@material-ui/core/SnackbarContent';
import sanitizeHtml from 'sanitize-html';

import { Message } from './style';

function Notification({ index, message, button }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(true);
  }, [index]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  function sanitize() {
    return sanitizeHtml(message, {
      allowedTags: ['strong', 'a'],
      allowedAttributes: { a: ['href'] },
    });
  }

  return (
    <SnackbarBase
      open={open}
      color="primary"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <SnackbarContentBase
        contentprops={{
          'aria-describedby': 'message-id',
        }}
        // prettier-ignore
        message={(
          <Message id="message-id">
            <span dangerouslySetInnerHTML={{ __html: sanitize() }} />
          </Message>
        )}
        action={button}
      />
    </SnackbarBase>
  );
}

export default Notification;
